/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import getEmploiInformationProgramsActions, {
    getEmploiInformationProgramsTypes,
} from '../../../../redux/editique/donneesEmploi/getEmploiInformationPrograms'
import { Get } from '../../../../serveur/axios'

function* getEmploiInformationProgramsSagas({ response }) {
    const {
        governorate,
        delegation,
        bureauEmploi,
        from,
        to,
        fromSecondary,
        toSecondary,
    } = response

    let url = `/editique-emploi/emploi_information_programs?`

    if (governorate) {
        url = `${url}&governorate=${governorate}`
    }
    if (delegation) {
        url = `${url}&delegation=${delegation}`
    }
    if (bureauEmploi) {
        url = `${url}&bureau_emploi=${bureauEmploi}`
    }
    if (from) {
        url = `${url}&from=${from}`
    }
    if (to) {
        url = `${url}&to=${to}`
    }
    if (fromSecondary) {
        url = `${url}&fromSecondary=${fromSecondary}`
    }
    if (toSecondary) {
        url = `${url}&toSecondary=${toSecondary}`
    }

    try {
        const res = yield Get(url)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    getEmploiInformationProgramsActions.getEmploiInformationProgramsSuccess(
                        res.data.data
                    )
                ),
            ])
        } else {
            yield put(
                getEmploiInformationProgramsActions.getEmploiInformationProgramsFailure(
                    res.data.data
                )
            )
        }
    } catch (error) {
        yield put(
            getEmploiInformationProgramsActions.getEmploiInformationProgramsFailure(
                error
            )
        )
    }
}

export function* getEmploiInformationProgramsSaga() {
    yield takeLatest(
        getEmploiInformationProgramsTypes.GET_EMPLOI_INFORMATION_PROGRAMS_REQUEST,
        getEmploiInformationProgramsSagas
    )
}
